(() => {
  const moneyText = (s) => s;
  const init = () => {
    const dataNode = document.querySelector('.mylilan-concealer-bundle-data');
    if (!dataNode || dataNode.dataset.initialized === 'true') return;

    let cfg;
    try { cfg = JSON.parse(dataNode.textContent); } catch (e) { console.error('[MyLilan Bundle] Invalid config', e); return; }
    if (!cfg?.variants?.length || !cfg?.tiers?.length) return;

    const section = dataNode.closest('.shopify-section') || document.querySelector('main') || document.body;
    const productForm = section.querySelector('product-form-component');
    if (!productForm) return;

    dataNode.dataset.initialized = 'true';
    document.body.classList.add('mylilan-concealer-bundle-page');
    section.classList.add('mylilan-concealer-bundle-section');

    const nativeId = productForm.querySelector('input[name="id"]')?.value;
    let primaryVariant = cfg.variants.find(v => String(v.id) === String(nativeId) && v.available)?.id
      || cfg.variants.find(v => v.available)?.id
      || cfg.variants[0].id;

    const wrap = document.createElement('div');
    wrap.className = 'mylilan-bundle-selector';
    productForm.parentNode.insertBefore(wrap, productForm);

    let selectedTier = 1;

    const optionHtml = (selectedId) => cfg.variants.map(v =>
      '<option value="' + v.id + '"' + (String(v.id) === String(selectedId) ? ' selected' : '') + (!v.available ? ' disabled' : '') + '>' +
      v.title.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') +
      '</option>'
    ).join('');

    const setPrimary = (id) => {
      primaryVariant = id;
      wrap.querySelectorAll('.mylilan-color-chip').forEach(btn => {
        btn.classList.toggle('is-active', String(btn.dataset.variantId) === String(id));
      });
      wrap.querySelectorAll('.mylilan-bundle-color-select').forEach(sel => { sel.value = String(id); });
    };

    const render = () => {
      const tierCards = cfg.tiers.map((tier, idx) => {
        const rows = idx === selectedTier
          ? '<div class="mylilan-bundle-rows">' +
              Array.from({length:tier.qty}, (_,i) =>
                '<label class="mylilan-bundle-row"><span>#' + (i+1) + '</span><select class="mylilan-bundle-color-select">' +
                optionHtml(primaryVariant) + '</select></label>'
              ).join('') +
            '</div>'
          : '';

        return '<button type="button" class="mylilan-bundle-card' + (idx === selectedTier ? ' is-selected' : '') + '" data-tier-index="' + idx + '">' +
          (tier.popular ? '<span class="mylilan-popular-badge">AM MEISTEN<br>GEWÄHLT</span>' : '') +
          '<span class="mylilan-radio-dot" aria-hidden="true"></span>' +
          '<span class="mylilan-tier-main"><strong>' + tier.label + '</strong><span class="mylilan-per-price">' + moneyText(tier.per) + '</span></span>' +
          '<span class="mylilan-tier-price"><strong>' + moneyText(tier.total) + '</strong><del>' + moneyText(tier.compare) + '</del></span>' +
          rows +
        '</button>';
      }).join('');

      wrap.innerHTML =
        '<div class="mylilan-primary-color">' +
          '<div class="mylilan-primary-label">Farbe: <strong>' + (cfg.variants.find(v => String(v.id)===String(primaryVariant))?.title || '') + '</strong></div>' +
          '<div class="mylilan-color-chips">' +
            cfg.variants.map(v =>
              '<button type="button" class="mylilan-color-chip' + (String(v.id)===String(primaryVariant) ? ' is-active' : '') + '" data-variant-id="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' +
              v.title.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') +
              '</button>'
            ).join('') +
          '</div>' +
        '</div>' +
        '<div class="mylilan-bundle-heading"><span></span><strong>BÜNDELN &amp; SPAREN</strong><span></span></div>' +
        '<div class="mylilan-bundle-cards">' + tierCards + '</div>' +
        '<div class="mylilan-bundle-note">🚚 Standardversand ab 50 € kostenlos</div>' +
        '<button type="button" class="mylilan-bundle-add">In den Warenkorb</button>' +
        '<div class="mylilan-bundle-error" role="alert" aria-live="polite"></div>';

      wrap.querySelectorAll('.mylilan-color-chip').forEach(btn => {
        btn.addEventListener('click', () => {
          setPrimary(btn.dataset.variantId);
          const title = cfg.variants.find(v => String(v.id)===String(primaryVariant))?.title || '';
          const label = wrap.querySelector('.mylilan-primary-label strong');
          if (label) label.textContent = title;
        });
      });

      wrap.querySelectorAll('.mylilan-bundle-card').forEach(card => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('select')) return;
          selectedTier = Number(card.dataset.tierIndex);
          render();
        });
      });

      wrap.querySelectorAll('.mylilan-bundle-color-select').forEach(sel => {
        sel.addEventListener('click', e => e.stopPropagation());
      });

      wrap.querySelector('.mylilan-bundle-add')?.addEventListener('click', addBundle);
    };

    const addBundle = async () => {
      const tier = cfg.tiers[selectedTier];
      const selects = Array.from(wrap.querySelectorAll('.mylilan-bundle-color-select'));
      const btn = wrap.querySelector('.mylilan-bundle-add');
      const error = wrap.querySelector('.mylilan-bundle-error');
      if (selects.length !== tier.qty) {
        if (error) error.textContent = 'Bitte wählen Sie für jedes Stück eine Farbe.';
        return;
      }

      const counts = {};
      selects.forEach(sel => {
        counts[sel.value] = (counts[sel.value] || 0) + 1;
      });
      const items = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity }));

      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt…';
      if (error) error.textContent = '';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body?.description || body?.message || 'Das Produkt konnte nicht hinzugefügt werden.');
        }
        const cartPath = root + 'cart';
        window.location.assign(root + 'discount/' + encodeURIComponent(tier.code) + '?redirect=' + encodeURIComponent(cartPath));
      } catch (e) {
        console.error('[MyLilan Bundle]', e);
        if (error) error.textContent = e?.message || 'Bitte versuchen Sie es erneut.';
        btn.disabled = false;
        btn.textContent = 'In den Warenkorb';
      }
    };

    render();

    const hideNative = () => {
      section.querySelectorAll('variant-picker, variant-picker-component, .variant-picker').forEach(el => {
        if (!el.closest('.mylilan-bundle-selector')) el.style.display = 'none';
      });
    };
    hideNative();
    setTimeout(hideNative, 600);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();